import Category from 'src/models/item/Category'
import Model, { ID, Integer, MODEL_LEVEL } from 'src/models/model'

export default class ActivityCategory extends Model {
  static name = 'ActivityCategory'

  static level = MODEL_LEVEL.SITE

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      category: {
        type: Category,
        reference: true,
        required: true
      },
      displayOrder: {
        type: Integer,
        default: 100
      }
    }
  }
}
